const projectBlogs = [
  {
    id: 1,
    slug: "creative-storyteller",
    blogDate: "2026-03-24",
    category: "AI / Full Stack / GenAI",
    title: "Creative Storyteller – Multimodal AI Story Engine",
    tagline:
      "An AI-powered storytelling system that transforms a simple idea into a cinematic, scene-based experience with text, images, and narration.",

    coverImage: "/images/CreativeStoryteller.png",
    architectureDiagram: "/images/Architectureforcreativestoryteller.png",

    shortDescription:
      "Creative Storyteller is a full-stack multimodal AI application that takes user inputs like topic, tone, language, audience, and duration, then generates a multi-scene cinematic story with narration, visuals, and audio.",

    useCase:
      "Traditional storytelling often requires multiple creative roles such as writers, illustrators, voice artists, and editors. Creative Storyteller explores how a single AI-driven system can combine those steps into one pipeline and instantly generate a multimedia storytelling experience for creators, educators, and digital content makers.",

    description:
      "Creative Storyteller acts like an AI Creative Director. The user provides high-level story parameters, and the system generates a structured story divided into scenes. Each scene includes narration text, AI-generated visual imagery, and audio narration. The frontend then presents the result as an automatic cinematic playback experience.",

    whatItDoes: [
      "Accepts user inputs such as topic, tone, language, audience, and duration.",
      "Generates a structured multi-scene story using Gemini models via Vertex AI.",
      "Creates scene visuals using Vertex AI image generation.",
      "Creates scene narration audio using Google Cloud Text-to-Speech.",
      "Stores generated media in Google Cloud Storage.",
      "Delivers a scene-by-scene cinematic playback experience in the frontend.",
    ],

    systemDesign: {
      architectureFlow:
        "User Input → Next.js Frontend → Django REST API on Cloud Run → Gemini via Vertex AI → Scene Processing Pipeline → Image Generation + Text-to-Speech → Google Cloud Storage → Frontend Playback",

      overview:
        "The frontend collects story parameters and sends them to the backend. The backend acts as a Creative Director Agent that orchestrates Gemini-based story generation, scene structuring, image generation, and narration synthesis. Generated media assets are stored in Google Cloud Storage, and their URLs are returned to the frontend for synchronized scene-by-scene playback.",

      sceneStructure: [
        "Narration text",
        "Visual prompt / visual imagery",
        "Narration audio",
      ],
    },

    techStack: {
      frontend: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
      backend: ["Python", "Django", "Django REST Framework"],
      aiCloud: [
        "Gemini models via Vertex AI",
        "Vertex AI image generation",
        "Google Cloud Text-to-Speech",
        "Google Cloud Storage",
        "Google Cloud Run",
      ],
      devops: ["Docker", "Vercel", "Cloud Run"],
    },

    keyFeatures: [
      "AI story generation using Gemini via Vertex AI",
      "Scene-based story structure",
      "AI-generated visuals for each scene",
      "Voice narration generation",
      "Automatic story playback",
      "Cloud storage for generated media",
      "Scalable backend deployed on Google Cloud Run",
    ],

    challenges: [
      "Maintaining story coherence across multiple generated scenes",
      "Coordinating asynchronous generation of images and narration",
      "Handling API limits and implementing graceful fallbacks",
      "Designing a structured scene format suitable for cinematic playback",
      "Creating a UI that presents multimodal outputs as one cohesive story experience instead of separate AI responses",
    ],

    solutionsAndLearnings:
      "This project showed that the hardest part of multimodal AI is not just calling a model, but orchestrating a full creative workflow. I learned how to combine story generation, image generation, voice synthesis, storage, and scalable APIs into one production-style pipeline. It also reinforced the idea that future AI experiences will move beyond simple text chat toward interactive multimedia interfaces.",

    accomplishments: [
      "Built a complete multimodal storytelling pipeline",
      "Integrated Gemini, Vertex AI image generation, and voice synthesis into one flow",
      "Created an interactive cinematic story playback experience",
      "Deployed the backend on Google Cloud Run",
    ],

    futureScope: [
      "AI-generated video scenes for fully animated stories",
      "Real-time story editing and branching narratives",
      "Character voices and emotion-aware narration",
      "Interactive storytelling experiences for education",
      "Collaborative storytelling between multiple users",
      "Evolving the project into a full AI creative production platform",
    ],

    links: {
      youtube: "https://youtu.be/P4COjdddRg8?si=L-WduKWyAilwnAS3",
    },

    tags: [
      "AI",
      "GenAI",
      "Multimodal AI",
      "Django",
      "Next.js",
      "Vertex AI",
      "Gemini",
      "Google Cloud",
      "Cloud Run",
      "Storytelling",
    ],
  },
];

export default projectBlogs;